import gql from "graphql-tag";
import {UCUMUnit} from "../../../helper/UCUMUnit";

export const getPatientSummary = gql`query getPatientSummary($patientId : Int!)
  {
    patientSummary(patientId: $patientId) {
      user {
        id
        subjectId
        enrollmentDate
        visit1Date
        blocked
        knowledgeLevel {
          key
          name
          level
        }
        patient {
          createdAt
          targetWeightValue
          targetWeightUnit
          patientId
          birthdate
          name {
            use
            given
            family
          }
          gender
          telecom {
            value
            system
            use
          }
        }
      }
      bloodPressure {
        component {
          code {
            coding {
              code
            }
          }
          valueQuantity(conversion: [{ toUnit: "${UCUMUnit.MILLIMETER_OF_MERCURY.unit}" }]) {
            id
            value
            unit
          }
        }
        status
      }
      weight {
        effectiveDateTime
        valueQuantity(conversion: [{ toUnit: "${UCUMUnit.KILOGRAM.unit}" }]) {
          value
          unit
        }
      }
      length {
        effectiveDateTime
        valueQuantity(conversion: [{ toUnit: "${UCUMUnit.CENTIMETER.unit}" }]) {
          value
        }
      }
      BMI {
        effectiveDateTime
        valueQuantity {
          code
          value
        }
      }
      LDL {
        valueQuantity(conversion: [{ toUnit: "${UCUMUnit.MILLIGRAM_PER_DECILITER.unit}" }]) {
          value
          unit
        }
      }
      LDLInPreferredUnit {
        valueQuantity {
          value
          unit
        }
      }
      HDL {
        valueQuantity(conversion: [{toUnit: "${UCUMUnit.MILLIGRAM_PER_DECILITER.unit}"}]) {
          value
          unit
        }
      }
      cholesterol {
        valueQuantity(conversion: [{toUnit: "${UCUMUnit.MILLIGRAM_PER_DECILITER.unit}"}]) {
          value
          unit
        }
      }
      HbA1c {
        valueQuantity(conversion: [{ toUnit: "${UCUMUnit.PERCENT.unit}" }]) {
          value
          unit
        }
      }
      HbA1cInPreferredUnit {
        valueQuantity {
          value
          unit
        }
      }
      eGFR {
        valueQuantity{
          value
        }
      }
      SDMEncounters {
        id
        encounterDate
        date
        status
        version
        DSSVersion
        DSSRelease
      }
      patientSettings {
        path
        value
      }
      outcomeComponents {
        key
        active
        reviewReminders
      }
      outcomeGoals {
        key
        value
        label
        color
        date
        extraInformation
      }
      behaviourComponents {
        status
        levelOfGuidance
        key
        stageKey
      }
      behaviourGoals {
        key
        value
        label
        color
        motivationColor
        motivationValue
        date
        extraInformation
      }
      targetVersion
      heartRate {
        valueQuantity(conversion: [{ toUnit: "${UCUMUnit.BPM.unit}" }]) {
          value
        }
      }
      lastCompletedSixMinuteWalkingTest {
        distanceWalked
      }
      dailySportsActivityWeekStartDate
    }
  }`;

export const dropOut = gql`mutation dropOut($patientId: Int)
  {
    createUpdatePatient(dropOut: true, patientId: $patientId) {
      user {
        patient {
          patientId
        }
      }
    }
  }`;

export const logOut = gql`mutation logOut($patientId: Int)
  {
    createUpdatePatient(logOut: true, patientId: $patientId) {
      user {
        patient {
          patientId
        }
      }
    }
  }`;

export const resetPassword = gql`mutation resetPassword($patientId: Int!)
  {
    setPasswordForPatient(patientId : $patientId)
  }`;

export const getEventData = gql`query getEventData($patientId: Int) {
  myDSSInfo (patientId: $patientId) {
    hadSecondVascularEventOnStatins
  }
}`;

export const blockAccount = gql`mutation blockAccount($patientId: Int, $block: Boolean)
  {
    createUpdatePatient(block: $block, patientId: $patientId) {
      user {
        patient {
          patientId
        }
      }
    }
  }`;
